/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pilot_Ended_TitleInputs */



/**
* | output |
* | --- |
* | "Your Wundo pilot has ended" |
*
* @param {Pilot_Ended_TitleInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const pilot_ended_title = /** @type {((inputs?: Pilot_Ended_TitleInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pilot_Ended_TitleInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Je pilot bij Wundo is afgelopen")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Votre pilote chez Wundo est terminé")
	return /** @type {LocalizedString} */ ("Your Wundo pilot has ended")
});